import {memo} from 'react'
import {Outlet} from 'react-router-dom'

// XXX Does it really need memo?
export const Layout = memo(function Layout() {
  return <Outlet />
})

try{ Layout.displayName ||= 'Layout' } catch {}